/**
 * Andre Garen - yuva motoru (Tur 23 EK10 \u00a72). Isaret: sections/ag-yuva.liquid ([data-ag-yuva] > [data-ag-yuva-aday]).
 * Kurallar sirali; yukaridan ilk uyan kazanir. Kosullar (adayin data- nitelikleri, bos = kosul yok):
 *   data-tb / data-te  tarih araligi: 'AA-GG' (her yil; 12-20..01-05 gibi yil donumu olur) ya da 'YYYY-AA-GG'
 *   data-gun           haftanin gunu: 1=Pzt .. 7=Paz; '5', '6,7', '1-5'
 *   data-sb / data-se  saat araligi 'SS:DD' (bitis dahil degil; bitis yoksa gun sonu; 22:00-02:00 gibi gece donumu olur)
 *   data-mod           day | night (dunya modu, <html data-ag-mode>; saat degil - K1)
 *   data-kisi          misafir | uye | testli | planli | instagram (window.AGKisi)
 * data-rol: kural | sirayla | varsayilan. Art arda gelen "sirayla" adaylar bir grup: her pazartesi 00:00 (Izmir) siradaki
 * (AGZaman.sirayla; baslangic haftasi AG_TAKVIM.siraBas); secilen grup uyesinin kosullari da uymali.
 * Hicbiri uymazsa ilk "varsayilan"; o da yoksa yuva gizli kalir (yer kaplamaz). Anahtar: data-kimlik -> window.agOz.
 * Yuvada data-banner="1" ise anma gununde (10 Kasim) hicbir sey gostermez (B064).
 * Karar istemcide; dakikada bir (AGZaman.her) ve mod degisince (ag:mode) yeniden verilir.
 */
(function () {
  'use strict';
  if (window.AGYuva) return;
  var D = document.documentElement;

  function hm(s) { var m = String(s || '').match(/^\s*(\d{1,2})[:.](\d{2})/); return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function gunler(s) {
    var g = [];
    String(s || '').split(/[,;\s]+/).forEach(function (p) {
      var r = p.match(/^([1-7])(?:-([1-7]))?$/); if (!r) return;
      var a = +r[1], b = r[2] ? +r[2] : a;
      for (var i = a; ; i = i % 7 + 1) { g.push(i); if (i === b) break; }
    });
    return g;
  }
  function tarihUyar(tb, te, d) {
    tb = String(tb || '').trim(); te = String(te || '').trim();
    if (!tb && !te) return true;
    var yilli = /^\d{4}-/.test(tb || te);
    var k = yilli ? d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) : pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
    if (yilli) return (!tb || k >= tb) && (!te || k <= te);
    if (tb && te && tb > te) return k >= tb || k <= te;
    return (!tb || k >= tb) && (!te || k <= te);
  }
  function saatUyar(sb, se, d) {
    var a = hm(sb), b = hm(se), m = d.getUTCHours() * 60 + d.getUTCMinutes();
    if (a == null && b == null) return true;
    if (a == null) a = 0;
    if (b == null) b = 1440;
    return a <= b ? (m >= a && m < b) : (m >= a || m < b);
  }
  function uyar(el, d, mod) {
    var g = el.getAttribute('data-gun'), md = el.getAttribute('data-mod'), ks = el.getAttribute('data-kisi');
    if (!tarihUyar(el.getAttribute('data-tb'), el.getAttribute('data-te'), d)) return false;
    if (g) { var gl = gunler(g); if (gl.length && gl.indexOf(d.getUTCDay() || 7) < 0) return false; }
    if (!saatUyar(el.getAttribute('data-sb'), el.getAttribute('data-se'), d)) return false;
    if (md && md !== 'hepsi' && md !== mod) return false;
    if (ks && ks !== 'hepsi' && !(window.AGKisi && window.AGKisi.mi(ks))) return false;
    return true;
  }
  function acikMi(el) { var k = el.getAttribute('data-kimlik'); return !k || !!(window.agOz && window.agOz(k)); }

  function sec(yuva, d) {
    var Z = window.AGZaman;
    if (yuva.getAttribute('data-banner') === '1' && Z && Z.ozelGun) { var oz = Z.ozelGun(d); if (oz && oz.tip === 'anma') return null; }
    var mod = D.getAttribute('data-ag-mode') === 'night' ? 'night' : 'day';
    var a = [].filter.call(yuva.children, function (x) { return x.hasAttribute('data-ag-yuva-aday'); });
    var varsayilan = null;
    for (var i = 0; i < a.length; i++) {
      var rol = a[i].getAttribute('data-rol');
      if (rol === 'sirayla') {
        var grup = [a[i]];
        while (i + 1 < a.length && a[i + 1].getAttribute('data-rol') === 'sirayla') grup.push(a[++i]);
        grup = grup.filter(acikMi);
        if (!grup.length) continue;
        var s = grup[Z ? Z.sirayla(grup.length, (window.AG_TAKVIM || {}).siraBas, d) : 0];
        if (uyar(s, d, mod)) return s;
        continue;
      }
      if (!acikMi(a[i])) continue;
      if (rol === 'varsayilan') { if (!varsayilan) varsayilan = a[i]; continue; }
      if (uyar(a[i], d, mod)) return a[i];
    }
    return varsayilan;
  }

  function uygula(yuva, d) {
    var k = sec(yuva, d);
    [].forEach.call(yuva.children, function (x) { if (x.hasAttribute('data-ag-yuva-aday')) x.hidden = x !== k; });
    yuva.hidden = !k;
    yuva.setAttribute('data-ag-yuva-secili', k ? (k.getAttribute('data-kimlik') || k.getAttribute('data-blok')) : '');
  }
  function hepsi(d) {
    var Z = window.AGZaman; d = d || (Z ? Z.simdi() : new Date(Date.now() + 3 * 36e5));
    [].forEach.call(document.querySelectorAll('[data-ag-yuva]'), function (y) { uygula(y, d); });
  }

  window.AGYuva = { yenile: hepsi, uyar: uyar, sec: sec, _gunler: gunler };
  if (window.AGZaman) window.AGZaman.her(hepsi); else hepsi();
  document.addEventListener('ag:mode', function () { hepsi(); });
  document.addEventListener('shopify:section:load', function () { hepsi(); });
})();
